export enum CountryCode {
  ZA = 'ZA',
  US = 'USA',
  UK = 'UK',
  Other = 'Other',
}
